import Papa from 'papaparse';
import { MdOutlineFileDownload } from 'react-icons/md';
import { Size } from '@Components/designConstants';
import { IconButton } from '@Components/IconButton';
import { download } from '@src/utils/download-utils';

// A pane's CSV download, beside its filter bar. Rows are built on click, header row first.
export const CsvDownloadButton = ({
  filename,
  rows
}: {
  filename: string;
  rows: () => unknown[][];
}) => (
  <IconButton
    size={Size.MD}
    tooltip={{ text: 'Download CSV' }}
    onClick={() => download(Papa.unparse(rows()), `${filename}.csv`, 'text/csv')}
  >
    <MdOutlineFileDownload />
  </IconButton>
);
